<template>
  <div>
    <el-card  v-auth="'/refundApproval/pageList'">
      <el-row :gutter="20">
        <el-col :span="3">
          <!-- <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree> -->
          <el-cascader style="width:100%" clearable collapse-tags v-model="subjectIds" :show-all-levels="false" :props="treeProps" placeholder="请输入所属科目" :options="treeData" @change="subjectSearchChange"></el-cascader>
        </el-col>
        <el-col :span="3">
          <el-input style="width: 100%;" :size="componentSize" v-model="searchForm.paidAmount" type="number" placeholder="商品金额" auto-complete="off" clearable></el-input>
        </el-col>
        <el-col :span="3">
          <el-input style="width: 100%;" :size="componentSize" v-model="searchForm.studentName" placeholder="请输入退单人" auto-complete="off" clearable></el-input>
        </el-col>
        <el-col :span="3">
          <el-input style="width: 100%;" :size="componentSize" v-model="searchForm.number" placeholder="请输入订单编号" auto-complete="off" clearable></el-input>
        </el-col>
        <el-col :span="4">
          <el-date-picker style="width: 100%;" v-model="searchForm.refundTime" @change=refundTimeChange type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-col>
        <el-col :span="3" v-show="nowIndex !=3">
          <el-select :size="componentSize" placeholder="状态" style="width:100%" :clearable='nowIndex == 1 ? false:true' v-model="searchForm.refund">
            <el-option :value="1" v-show="nowIndex == 2" label="同意"></el-option>
            <el-option :value="-1" v-show="nowIndex == 2" label="驳回"></el-option>
            <el-option :value="2" v-show="nowIndex == 1" label="审批中"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3" style="float:right">
          <el-button style="float:right" :size="componentSize" type="primary" @click="pageList"
                     v-auth="'/refundApproval/pageList'" icon="el-icon-search">查询
          </el-button>
          <!-- <el-button
                      :size="componentSize"
                      type="primary"
                      @click="reset"
                      icon="el-icon-refresh"
                    >重置</el-button> -->
        </el-col>
      </el-row>
    </el-card>

    <div class="tab-bar">
      <div class="bar-left">
        <div :class="nowIndex==1?'bar-item-visited':'bar-item'" @click="nowIndex=1;searchForm.refund = 2;searchForm.refundTime=[];">待我审批</div>
        <div :class="nowIndex==3?'bar-item-visited':'bar-item'" @click="nowIndex=3;searchForm.refund = 3;searchForm.refundTime=[];">自动审批</div>
        <div :class="nowIndex==2?'bar-item-visited':'bar-item'" @click="nowIndex=2;searchForm.refund = '';searchForm.refundTime=[];">我已审批</div>
      </div>

    </div>

    <el-card class="box-card" style="margin-top: 0px;">
      <el-table v-show="nowIndex==1" ref="multipleTable" :data="page.rows" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" style="width: 100%;" border>
        <el-table-column show-overflow-tooltip prop="number" align="center" label="订单编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="studentName" align="center" label="下单人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderName" align="center" label="商品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="totalAmount" align="center" label="商品金额"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" align="center" label="退单人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="updateTime" align="center" label="退单时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="refundReason" align="center" label="退单原因"></el-table-column>
        <el-table-column show-overflow-tooltip prop="agentUserName" align="center" label="审批人"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" style="margin-right: 10px" :underline="false" @click="myAgreen(scope.row.id,scope.row.sourceType,scope.row.partType,scope.row.textBookPrice)"  v-auth="'/refundApproval/agree'">同意</el-link>
            <el-link type="danger" :underline="false" @click="dialogVisible = true;approveStatus = -1;approveId = scope.row.id;ruleForm.refuseRefundReason=''"   v-auth="'/refundApproval/refund'">驳回</el-link>
            <!--<el-button type="primary" @click="dialogVisible = true;approveStatus = 1;approveId = scope.row.id;ruleForm.refuseRefundReason=''" round>同意</el-button>-->
            <!--<el-button type="danger" @click="dialogVisible = true;approveStatus = -1;approveId = scope.row.id;ruleForm.refuseRefundReason=''" round>驳回</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-table v-show="nowIndex==2" ref="multipleTable" :data="page.rows" v-loading="loading" element-loading-text="拼命加载中" tooltip-effect="dark" style="width: 100%;" border>
        <el-table-column show-overflow-tooltip align="center" label="状态">
          <template v-show="nowIndex !=2" slot-scope="scope">
            <span v-if="scope.row.refund == 1" >同意</span>
            <span v-if="scope.row.refund == -1">驳回</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="number" align="center" label="订单编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="studentName" align="center" label="下单人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderName" align="center" label="商品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="totalAmount" align="center" label="商品金额"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" align="center" label="退单人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="updateTime" align="center" label="退单时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="refundReason" align="center" label="退单原因"></el-table-column>
        <el-table-column show-overflow-tooltip prop="refuseRefundReason" align="center" label="审批备注"></el-table-column>
        <el-table-column show-overflow-tooltip prop="agentUserName" align="center" label="审批人"></el-table-column>
      </el-table>
      <el-table v-show="nowIndex==3" ref="multipleTable" :data="page.rows" v-loading="loading" element-loading-text="拼命加载中" tooltip-effect="dark" style="width: 100%;" border>
        <!-- <el-table-column show-overflow-tooltip align="center" label="状态">
          <template v-show="nowIndex !=2" slot-scope="scope">
            <span v-if="scope.row.refund == 1">同意</span>
            <span v-if="scope.row.refund == -1">驳回</span>
          </template>
        </el-table-column> -->
        <el-table-column show-overflow-tooltip prop="number" align="center" label="订单编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="studentName" align="center" label="下单人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderName" align="center" label="商品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="totalAmount" align="center" label="商品金额"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" align="center" label="退单人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="updateTime" align="center" label="退单时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="refundReason" align="center" label="退单原因"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="refuseRefundReason" align="center" label="审批备注"></el-table-column> -->
        <!-- <el-table-column v-show="nowIndex !=2" show-overflow-tooltip prop="agentUserName" align="center" label="审批人"></el-table-column> -->
      </el-table>
      <el-pagination background layout="total, prev, pager, next" style="margin-top: 20px;text-align: right;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>

    <el-dialog title="退单审批" :visible.sync="dialogVisible" width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="自主订单" v-if="ruleForm.sourceType == '自主下单'">
          <span style="color: red">退单会直接退还给该用户</span>
        </el-form-item>
        <el-form-item label="审批备注" prop="refuseRefundReason">
          <el-input v-model="ruleForm.refuseRefundReason" placeholder="请输入审批备注" style="width: 70%"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="approveSure('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!--部分退单审批-->
    <el-dialog title="部分退款审批" :visible.sync="chanrgepartVisible" width="30%">
      <el-form :model="chanrgepartForm" :rules="chanrgepartrules" ref="chanrgepartForm">
        <el-form-item label="审批备注" prop="refuseRefundReason">
          <el-input v-model="chanrgepartForm.refuseRefundReason" placeholder="请输入审批备注" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="退款金额" prop="chanrgepartMoney">
          <span>{{chanrgepartForm.chanrgepartMoney}}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="chanrgepartVisible = false">取 消</el-button>
        <el-button type="primary" @click="approvepartSure('chanrgepartForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: { ElImageViewer },
  data () {
    return {
      subjectIds: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      treeProps: {
        // value: 'subjectCourseId',
        // label: 'name',
        // children: 'children',
        // checkStrictly: true,
        // multiple: true,
        value: "id",
        label: "name",
        children: "children",
        multiple: true
      },
      approveId: '',
      approveStatus: '',
      ruleForm: {
        refuseRefundReason: ''
      },
        chanrgepartForm: {
        refuseRefundReason: '',
            chanrgepartMoney:""
      },
      rules: {
        refuseRefundReason: [
          { required: true, message: '请输入审批备注', trigger: 'change' }
        ],
      },
        chanrgepartrules: {
        refuseRefundReason: [
          { required: true, message: '请输入审批备注', trigger: 'change' }
        ],
      },
      dialogVisible: false,
        chanrgepartVisible: false,
        chanrgepartMoney: '',
      componentSize: "",
      showViewer: false,
      urlList: [],
      nowIndex: 1,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      options: [],
      searchForm: {
        studentName: '',
        number: '',
        type: null,
        refund: 2,
        refundTime: ''
      },

      formLabelWidth: "80px",
      selection: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    }
  },
  methods: {
    getTreeData () {
      this.api.campus.getPermissionSubjectTree().then(result => {
        for (let item of result.data) {
          if (item.children.length != 0) {
            for (let items of item.children) {

              delete items.children;

              // if (items.children.length != 0) {
              //   for (let itemss of items.children) {
              //     delete itemss.children;
              //   }
              // } else {
              //   // delete items.children;
              // }
            }
          } else {
            // delete item.children;
          }
        }

        this.treeData = result.data;
      })
        .catch(error => {
          console.log(error);
        });
    },
    subjectSearchChange () {
      if (this.subjectIds) {
        this.searchForm.subjectIds = []
        this.subjectIds.forEach(item => {
          this.searchForm.subjectIds.push(item[1])
        })
      } else {
        this.searchForm.subjectIds = []
      }
    },
    refundTimeChange (val) {
      this.searchForm.refundOrderStartTime = val[0];
      this.searchForm.refundOrderEndTime = val[1];
      console.log(this.searchForm.refundOrderStartTime);
      console.log(this.searchForm.refundOrderEndTime);

    },
    onPreview (row) {
      this.urlList = [];
      row.row.attachmentList.forEach(e => {
        this.urlList.push(e.url);
      });
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer () {
      this.showViewer = false;
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    setComponentSize () {
      if (document.body.clientWidth <= 992) {
        this.componentSize = "mini";
        return;
      }
      if (document.body.clientWidth <= 1200) {
        this.componentSize = "small";
        return;
      }
      if (document.body.clientWidth <= 1920) {
        this.componentSize = "medium";
        return;
      }
    },
    getStudent () {
      this.api.student
        .getStudent({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      // this.searchForm.sortName = this.page.sortName;
      // this.searchForm.sortOrder = this.page.sortOrder;

      // if(this.nowIndex == 1){
      //     this.searchForm.refund = 2;
      // }else {
      //     this.searchForm.refund = '';
      // }
      this.api.agentAmountLog
        .queryApproverV2(this.searchForm)
        .then(result => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },

    reset () {
      this.searchForm.userIds = [];
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
      myAgreen(id,sourceType,partType,textBookPrice){
          this.approveId = id;

          if(partType == '1'){
          //    部分退款审批
              this.chanrgepartVisible = true;
              this.chanrgepartForm.chanrgepartMoney = textBookPrice;
          }else{
          //    退单审批
              this.dialogVisible = true;
              this.approveStatus = 1;
              this.ruleForm.refuseRefundReason='';
              this.ruleForm.sourceType = sourceType;
          }
      },
    approveSure (ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {

          let param = {
            id: this.approveId,
            refuseRefundReason: this.ruleForm.refuseRefundReason,
            refund: this.approveStatus
          };
          this.api.agentAmountLog
            .refundOrderAudit(param).then(result => {
              console.log(result);
              this.dialogVisible = false;
              this.pageList();

              // this.page.rows = result.data;
              // this.page.total = result.data.total;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
      approvepartSure (ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {

          let param = {
            id: this.approveId,
            refuseRefundReason: this.chanrgepartForm.refuseRefundReason,
              textBookPrice:  this.chanrgepartForm.chanrgepartMoney,
              refund:1
          };
          this.api.agentAmountLog
            .partRefundOrderAudit(param).then(result => {
              console.log(result);
              this.chanrgepartVisible = false;
              this.pageList();

            })
            .catch(error => {
              console.log(error);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },



  },
  watch: {
    nowIndex (val) {

      this.pageList();
    },

    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    viewFormVisible: function (newVal) {
      if (!newVal) {
        // this.$refs.editForm.resetFields();
        // this.pageList();
      } else {
        this.getStudent();
      }
    }
  },
  mounted () {
    this.pageList();
    this.getTreeData();
  }
};
</script>
<style lang="less" scoped>
.el-select {
  width: 100% !important;
}
.el-button.is-round {
  padding: 7px 15px;
}
.tab-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  background: rgb(246, 249, 250);
  padding-top: 10px;
  .bar-right {
    height: 40px;
    padding-right: 10px;
    span {
      color: #455a64;
      text-align: right;
      line-height: 40px;
      font-size: 16px;
    }
  }
  .bar-left {
    display: flex;
    flex-direction: row;
    .bar-item {
      font-size: 14px;
      color: #455a64;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      text-align: center;
      width: 100px;
    }
    .bar-item-visited {
      font-size: 14px;
      color: rgb(77, 148, 255);
      height: 40px;
      text-align: center;
      width: 100px;
      cursor: pointer;
      line-height: 40px;
      background: #ffffff;
    }
    .bar-item:hover {
      font-size: 14px;
      text-align: center;
      cursor: pointer;
      color: rgb(77, 148, 255);
      height: 40px;
      width: 100px;
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/refundApproval/index.vue